uniformsDataservice.$inject = ['userTracking']

function uniformsDataservice (userTracking) {
  var _uniformsService = null
  var _formId = null
  var _opportunityId = null

  function initPromise (uniformsService, formId) {
    _uniformsService = uniformsService
    _formId = formId

    return _uniformsService.get(formId).promise
      .then(function (res) {
        return res.data
      })
  }

  function savePromise (fields) {
    var data = {
      fields: fields,
      formId: _formId
    }
    var promise = null

    if (!_opportunityId) {
      userTracking.onRequest(data, 'create')
      promise = _uniformsService.create(data).promise
        .then(function (res) {
          userTracking.onResponse(res.data, 'create')
          _opportunityId = res.data.opportunityId
          if (res.data.status !== 'OK') {
            userTracking.onValidityFailure()
            throw res
          }
        })
    } else {
      userTracking.onRequest(_opportunityId, 'update')
      promise = _uniformsService.update(_opportunityId, data).promise
        .then(function (res) {
          userTracking.onResponse(res.data, 'update')
          _opportunityId = res.data.opportunityId
          if (res.data.status !== 'OK') {
            userTracking.onValidityFailure()
            throw res
          }
        })
    }

    return promise
      .then(function () {
        userTracking.onRequest(_opportunityId, 'submit')
        return _uniformsService.submit(_opportunityId).promise
      })
      .then(function (res) {
        userTracking.onResponse(res.data, 'submit')
      })
  }

  return {
    initPromise: initPromise,
    savePromise: savePromise
  }
}

module.exports = uniformsDataservice
